import ActionDialog from "./ActionDialog";
import { cancelDashboardRequestAPI } from "../../../../utils/api/ludDashboard";

// "Cancel -> Confirm Cancellation" for a dashboard request. The server decides
// whether the request can still be canceled and by whom (pending, owner or
// administrator); the row only offers the button when the API says so.
export default function CancelRequestDialog({ requestId, t, onClose, onDone }) {
  const token = localStorage.getItem("auth-token");
  const r = t.row;
  return (
    <ActionDialog
      t={t}
      title={r.cancelTitle}
      description={r.cancelText}
      reason={{ label: r.cancelNote, required: false }}
      confirmLabel={r.confirmCancellation}
      danger
      onClose={onClose}
      onConfirm={async (note) => {
        await cancelDashboardRequestAPI(token, requestId, note);
        await onDone?.();
      }}
    />
  );
}
